import classNames from 'classnames';
import { Component, PropsWithChildren } from 'react';
import { Label } from "src/ui";
import { UnstyledButton } from '../Buttons';
import "./FormSection.scss";
import Visage2Icon from 'src/visage2/Visage2Icon/Visage2Icon';

interface IProps {
    title?: string
    isExpandable?: boolean
    className?: string;
}

interface IState {
    isExpanded: boolean
}

type Props = PropsWithChildren<IProps>;

class FormSection extends Component<Props, IState> {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false
        }
    }

    getLabel() {
        if (this.props.isExpandable) {
            return (
                <UnstyledButton className="no-user-select" onClick={() => {
                    this.setState({
                        isExpanded: !this.state.isExpanded
                    });
                }}>
                    <div style={{
                        verticalAlign: "2px",
                        display: "inline-block"
                    }}>
                        <Visage2Icon icon={this.state.isExpanded ? "add" : "minus"} />
                    </div>
                    <div style={{
                        verticalAlign: "middle",
                        display: "inline-block"
                    }}>
                        <Label size="body-2" weight="medium">
                            {
                                this.props.title
                            }
                        </Label>
                    </div>
                </UnstyledButton>
            )
        }

        return (
            <Label size="body-2" weight="medium">
                {
                    this.props.title
                }
            </Label>
        )
    }

    render() {
        return (
            <div className={classNames("FormSection form-item-width", this.props.className)}>
                {!!this.props.title && this.props.title.length > 0 && (
                    <div>{this.getLabel()}</div>
                )}
                { this.props.isExpandable && !this.state.isExpanded
                    ? null
                    : this.props.children}
            </div>
        )
    }
}

export default FormSection
